import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";
import { sendWelcomeMail } from "DashboardUserAction";

class TestEmail extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {
    // this.props.fetchTemplate(this.props.session);
  }

  onSubmitForm = (data) => {
    this.setState({ loading: true });
    this.props.sendWelcomeMail(
      this.props.session,
      { email: data.email },
      (response) => {
        if (response.success === 1) {
          this.props.showSuccess(LocaleStrings.user_message_welcome_email_sent);
          this.setState({ loading: false });
          this.props.closeTestEmailModal();
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
          this.setState({ loading: false });
        }
      }
    );
  };

  closeTestEmailModal = () => {
    this.props.closeTestEmailModal();
  };

  render() {
    var { handleSubmit, pristine, invalid, submitting, testemailModal } =
      this.props;

    return (
      <Modal
        show={testemailModal.show === true ? true : false}
        onHide={this.closeTestEmailModal}
        dialogClassName="modal-md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        enforceFocus={false}
        animation={true}>
        <form
          onSubmit={handleSubmit(this.onSubmitForm)}
          encType="multipart/form-data">
          <Modal.Header>
            <Modal.Title>
              <div className="title-modal">
                {LocaleStrings.setting_email_template_testemail_header}
              </div>
            </Modal.Title>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={this.closeTestEmailModal}>
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body className="scrollable-modal">
            <div className="row h-full">
              <div className="col-sm-8">
                <Field
                  name="email"
                  label="Receiver's Email"
                  placeholder="Receiver's Email"
                  type="text"
                  component={this.renderFieldText}
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                />
              </div>
              <div className="col-sm-4 bg-white-">
                {/* <div className="email-template-info-container mt-3"></div> */}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              className="btn btn-custom-white"
              onClick={this.closeTestEmailModal}>
              {LocaleStrings.button_close}
            </Button>

            <Button
              type="submit"
              className="btn-custom-blue"
              loading={this.state.loading}>
              {LocaleStrings.button_send}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

function validate(values) {
  var errors = {};

  return errors;
}

function mapStateToProps(state) {
  var initVals = {};
  let user = state.user;
  initVals.email = user.email;

  return {
    session: state.session,
    initialValues: initVals,
  };
}

export default connect(mapStateToProps, {
  sendWelcomeMail,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "Test Email",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(TestEmail)
);
